/** @format */

import * as React from 'react'
import { interleave } from 'fe-lib-sequences'
import { subscribe, getState, useDarkTheme, useLightTheme } from './store'
export { subscribe, getState, useDarkTheme, useLightTheme }

const getIn = (cursor = [], obj) => {
  try {
    if (null == obj) return obj
    if (!cursor.length) return obj
    const [current, ...rest] = cursor
    return getIn(rest, obj[current])
  } catch (_err) {
    return undefined
  }
}

const getThemeValue = state => (...templateLiteral) => {
  const [parts, ...interops] = templateLiteral
  const cursor = interleave(parts, interops)
    .join('')
    .split(/[/]/)
  return getIn(cursor, state) || ''
}

export const useTheme = Comp =>
  class extends React.Component {
    componentDidMount() {
      this.mount = true
      this.unsubscribe = subscribe(() => this.mount && this.forceUpdate())
    }

    componentWillUnmount() {
      this.mount = false
      this.unsubscribe()
    }

    render() {
      return <Comp {...this.props} $theme={getThemeValue(getState())} />
    }
  }
